import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-4 h-full overflow-auto flex flex-col" }
const _hoisted_2 = { class: "flex items-center justify-between mb-3" }
const _hoisted_3 = {
  key: 0,
  class: "text-14px text-black-lp-300"
}
const _hoisted_4 = {
  key: 1,
  class: "ml-auto"
}
const _hoisted_5 = {
  key: 1,
  class: "overflow-auto flex-1 text-14px"
}
const _hoisted_6 = {
  key: 1,
  class: "flex items-center gap-2"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_9 = { class: "text-black-lp-300 font-semibold line-clamp-2 w-50" }
const _hoisted_10 = { class: "flex flex-row items-center gap-1" }
const _hoisted_11 = { class: "text-12px text-gray-lp-300" }
const _hoisted_12 = {
  key: 2,
  class: "whitespace-nowrap"
}
const _hoisted_13 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_TableDetail = _resolveComponent("TableDetail")!
  const _component_ImagePreview = _resolveComponent("ImagePreview")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.error)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 0,
          errorType: _ctx.INTERNAL_SERVER_ERROR,
          onTryAgain: _ctx.fetchData,
          textButtonSuccess: _ctx.$t('pickupDashboard.tryAgain')
        }, null, 8, ["errorType", "onTryAgain", "textButtonSuccess"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, [
      (_ctx.selectedCount > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.selectedCount) + " " + _toDisplayString(_ctx.$t("pickupDashboard.selectedSender")), 1))
        : _createCommentVNode("", true),
      (_ctx.selectedCount > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode(_component_LpButton, {
              title: _ctx.$t('pickupDashboard.booking'),
              color: "red-lp-100",
              textColor: "white",
              disabled: _ctx.selectedEligibleCount === 0,
              onClick: _ctx.onBulkTransferPickUp,
              iconLeft: 'ics_o_booking_white'
            }, null, 8, ["title", "disabled", "onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.error)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode(_component_TableDetail, {
            columns: _ctx.columns,
            data: _ctx.pagedData,
            isLoading: _ctx.isLoading,
            sortBy: _ctx.sortBy,
            sortDir: _ctx.sortDir,
            startIndex: _ctx.startIndex,
            pagination: _ctx.pagination,
            "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
            renderedData: _ctx.pagedData.length,
            isCheckboxDisabledFn: _ctx.isCheckboxDisabled,
            isFiltering: _ctx.isFiltering,
            onSetPage: _ctx.onSetPage,
            onSort: _ctx.onSort,
            onRowTransfer: _ctx.onTransferPickUpRow,
            onSelectToggle: _ctx.onSelectToggle,
            onToggleSelectAll: _ctx.onToggleSelectAll
          }, {
            cell: _withCtx(({ item, col }) => [
              (col.key === 'shipment_id')
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(item.shipment_id || "-"), 1)
                  ], 64))
                : (col.key === 'sender_name')
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      (!item.sender_name)
                        ? (_openBlock(), _createBlock("div", _hoisted_7, "-"))
                        : (_openBlock(), _createBlock("div", _hoisted_8, [
                            _createVNode("div", _hoisted_9, _toDisplayString(_ctx.ellipsis(item.sender_name || "-")), 1),
                            _createVNode("div", _hoisted_10, [
                              _createVNode("div", _hoisted_11, _toDisplayString(_ctx.formatPhoneNumber(item.sender_phone) || "-"), 1),
                              _createVNode("img", {
                                src: 
                      require('@/app/ui/assets/svg/ics_o_whatsapp-background.svg')
                    ,
                                class: "w-4 h-4 cursor-pointer",
                                alt: "whatsapp",
                                onClick: ($event: any) => (_ctx.onOpenWa(item.sender_phone))
                              }, null, 8, ["src", "onClick"])
                            ])
                          ]))
                    ]))
                  : (col.key === 'shipment_type')
                    ? (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString(_ctx.formatShipmentType(item.shipment_type)), 1))
                    : (col.key === 'total_quantity')
                      ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                          _createTextVNode(_toDisplayString(_ctx.fmtQty(item.total_quantity)), 1)
                        ], 64))
                      : (col.key === 'status_at')
                        ? (_openBlock(), _createBlock(_Fragment, { key: 4 }, [
                            _createTextVNode(_toDisplayString(_ctx.formatDate(item.status_at)), 1)
                          ], 64))
                        : (col.key === 'bukti_pickup')
                          ? (_openBlock(), _createBlock(_Fragment, { key: 5 }, [
                              (item.proofs.length === 0)
                                ? (_openBlock(), _createBlock("div", _hoisted_13, "-"))
                                : (_openBlock(), _createBlock("button", {
                                    key: 1,
                                    class: "text-red-lp-100 underline",
                                    onClick: ($event: any) => (_ctx.onShowProof(item))
                                  }, _toDisplayString(_ctx.$t("pickupDashboard.viewProof")), 9, ["onClick"]))
                            ], 64))
                          : (col.key === 'booking')
                            ? (_openBlock(), _createBlock("img", {
                                key: 6,
                                src: require('@/app/ui/assets/svg/ics_o_booking.svg'),
                                class: 
                item.is_able_to_booking === false
                  ? 'w-5 h-5 opacity-50 cursor-not-allowed'
                  : 'w-5 h-5 cursor-pointer'
              ,
                                alt: "booking",
                                onClick: ($event: any) => (item.is_able_to_booking === false ? {} : _ctx.onBooking(item))
                              }, null, 10, ["src", "onClick"]))
                            : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "data", "isLoading", "sortBy", "sortDir", "startIndex", "pagination", "renderedData", "isCheckboxDisabledFn", "isFiltering", "onSetPage", "onSort", "onRowTransfer", "onSelectToggle", "onToggleSelectAll"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ImagePreview, {
      modelValue: _ctx.showImagePreview,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.showImagePreview = $event)),
      data: _ctx.images,
      image: _ctx.image,
      isTerm: false,
      onClose: _ctx.closeImagePreview
    }, null, 8, ["modelValue", "data", "image", "onClose"])
  ]))
}